import { useNavigate } from "react-router-dom";
import { Glossed } from "@/components/Glossary";

const BlocksButton = ({ n, why, onClick, testid, className = "" }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`text-[#C2261D] underline decoration-dotted underline-offset-2 hover:decoration-solid ${className}`}>
    {n} bloqueio{n > 1 ? "s" : ""}{why ? `: ${why}` : ""}
  </button>
);

// Etiqueta do cartão: «Para escritura · faltam N» + bloqueios a vermelho (abrem o aviso) + «Responder a N perguntas».
export function CardTag({ pid, card: c, className = "", testid, extrasOnly = false, big = false }) {
  const navigate = useNavigate();
  const go = (e, hash) => { e.stopPropagation(); e.preventDefault(); navigate(`/processo/${pid}${hash}`); };
  const blocks = c.blocks || [];
  const first = blocks[0];
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      {!extrasOnly && <span className={className} data-testid={testid}>
        <Glossed text={c.tag_main ?? c.tag} steps={c.counts?.step_labels} />
        {first && <>{c.tag_main ? " · " : ""}<BlocksButton n={blocks.length} onClick={(e) => go(e, first.target || `#doc-${first.key}`)} testid={`${testid}-blocks`} /></>}
      </span>}
      {extrasOnly && first && <BlocksButton n={blocks.length} why={blocks.length === 1 ? first.why : null} onClick={(e) => go(e, first.target || `#doc-${first.key}`)} testid={`${testid}-blocks`}
        className="text-sm font-semibold px-3 py-1.5 rounded-lg bg-red-50" />}
      {c.questions > 0 && (
        <button type="button" onClick={(e) => go(e, "#sec-situacoes")} data-testid={`${testid}-questions`}
          className={`text-[13px] ${big ? "lg:text-sm" : ""} font-semibold px-2.5 py-0.5 rounded-full border border-amber-300 text-[#B45309] bg-white hover:bg-amber-50 transition-colors`}>
          Responder a {c.questions} pergunta{c.questions > 1 ? "s" : ""}
        </button>
      )}
    </span>
  );
}
